export default "__VITE_ASSET__VD5P7lAW__"